import { LabelSelectionState, RootState } from '@/store/types';
import { Module } from 'vuex';
import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    labelSelectionSkuMap: []
  },
  getters: {
    getCount(state) {
      return state.labelSelectionSkuMap.length;
    },
    getSkus(state) {
      return state.labelSelectionSkuMap;
    }
  },
  mutations: {
    addSku(state, productSku: string) {
      state.labelSelectionSkuMap.push({ sku: productSku, amount: 1 });
    },
    setSkuList(state, skuList: string[]) {
      state.labelSelectionSkuMap = skuList.map((productSku) => ({ sku: productSku, amount: 1 }));
    },
    removeSku(state, productSku: string) {
      state.labelSelectionSkuMap
        .splice(state.labelSelectionSkuMap.findIndex((item) => item.sku === productSku), 1);
    },
    clearSkus(state) {
      state.labelSelectionSkuMap = [];
    },
    setAmount(state, labelItem: { sku: string; amount: number }) {
      state.labelSelectionSkuMap.find((item) => item.sku === labelItem.sku).amount = labelItem.amount;
    },
    restoreLabelPrint(state, labelItem: { sku: string; amount: number }) {
      if (!state.labelSelectionSkuMap.find((item) => item.sku === labelItem.sku)) {
        state.labelSelectionSkuMap.push({ sku: labelItem.sku, amount: labelItem.amount });
      }
    }
  }
} as Module<LabelSelectionState, RootState>;
